import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../state/stores/user';
import { drawTicketActions } from '../../state/stores/drawticket';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';

import { Header } from '../Header';
import { Footer } from '../Footer';
import { MobileMenu } from '../MobileMenu';

import './style.scss';

const Layout = ({ getPlayerData, setGameOver, children, styleVariant = 'green' }) => {
    useEffect(() => {
        getPlayerData();
        setGameOver();
    }, [getPlayerData, setGameOver]);

    return (
        <StaticQuery
            query={graphql`
                query SiteTitleQuery {
                    site {
                        siteMetadata {
                            title
                            mainMenu {
                                uri
                                title
                            }
                            footerMenu {
                                uri
                                title
                            }
                            socialLinks {
                                servicename
                                url
                            }
                        }
                    }
                }
            `}
            render={data => {
                const { siteMetadata } = data.site;

                return (
                    <>
                        <div id="layout" className={`layout layout-${styleVariant}`}>
                            <div id="layout-bg" className="layout-bg">
                                <Header {...siteMetadata} />
                                {children}
                                <Footer {...siteMetadata} />
                            </div>
                        </div>
                        <MobileMenu menuItems={[...siteMetadata.mainMenu]} />
                    </>
                );
            }}
        />
    );
};

Layout.propTypes = {
    getPlayerData: PropTypes.func.isRequired,
    setGameOver: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    styleVariant: PropTypes.string,
};

export default connect(null, dispatch => ({
    getPlayerData: userActions(dispatch).getPlayerData,
    setGameOver: drawTicketActions(dispatch).setGameOver,
}))(Layout);
